import styles from './index.module.less';
import template from './index.art';
import { IOYInputRangeState, IOYInputRangeProps } from "./const";
import OY from '../../types/OY';
import valid from '../../utils/valild';
import { jeact } from '../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYInputRange extends OY<IOYInputRangeProps, IOYInputRangeState> {
  static displayName = 'OYInputRange';

  static defaultProps: Partial<IOYInputRangeProps> = {
    growingTrack: true,
    value: [],
    prefix: '',
    placeholder: '',
    valtype: 'any',
    decimal: 3,
    maxLength: 15
    // unit: 'mm',
  };

  state: IOYInputRangeState = {
    placeholder: ['', '']
  }

  $node = {
    startInput: $(),
    endInput: $()
  }

  getDerivedStateFromProps(props: IOYInputRangeProps, state: IOYInputRangeState) {
    const { placeholder = '' } = props
    if (typeof placeholder === 'string') {
      state.placeholder = [placeholder, placeholder]
    } else {
      state.placeholder = [placeholder[0], placeholder[1] || placeholder[0]]
    }
    return { ...state };
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode() {
    this.$node = {
      startInput: this.$el.find('input[name=start]'),
      endInput: this.$el.find('input[name=stop]')
    }
  }

  bindStartInput() {
    const { props } = this;
    this.$node.startInput.change((ev: Event) => {
      let startValue = this.$node.startInput.val();
      const endValue = this.$node.endInput.val();
      if (props.valtype) {
        const isValid = valid(startValue, props.valtype, props.decimal);
        if (!isValid) {
          this.$node.startInput.val('')
          startValue = '';
        }
      }
      this.eventEmitter.emit('onChange', [startValue, endValue])
    })
  }

  bindEndInput() {
    const { props } = this;
    this.$node.endInput.change((ev: Event) => {
      const startValue = this.$node.startInput.val();
      let endValue = this.$node.endInput.val();
      if (props.valtype) {
        const isValid = valid(endValue, props.valtype, props.decimal);
        if (!isValid) {
          endValue = '';
          this.$node.endInput.val('')
        }
      }
      this.eventEmitter.emit('onChange', [startValue, endValue])
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYInputRange/index.ts